<nav class="navbar navbar-expand-lg navbar-light bg-dark sticky-top ">
  <div class="container-fluid">


    <a class="navbar-brand text-white" href="#">Elección Consecutiva 2023-2024</a>
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent"
      aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0" *ngIf="config">
        <li class="nav-item">
          <a class="nav-link active text-white" aria-current="page" [routerLink]="['/home']">Documentos</a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-white" aria-current="page" [routerLink]="['/contendientes']">Avisos de Intención</a>
        </li>
        <li class="nav-item" *ngIf="config.MostrarMenuRenuncias">
          <a class="nav-link text-white" aria-current="page" [routerLink]="['/renuncias']">Renuncias</a>
        </li>
        <!-- 
        <li class="nav-item">
          <a class="nav-link text-white" aria-current="page" [routerLink]="['/licencias']">Licencias</a>
        </li>
        <li class="nav-item">
          <a class="nav-link text-white" aria-current="page" [routerLink]="['/funciones']">Funciones</a>
        </li> -->

        <li class="nav-item">
          <div class="align-text-bottom">
            <small class="badge bg-secondary">
              {{ActualizacionAl}}
            </small>
          </div>
        </li>
      </ul>
     
      <!-- <form class="d-flex">
        
        <br>
        <input class="form-control me-2" type="search" placeholder="Buscar" aria-label="Search"
          (keyup.enter)="buscarContendiente(buscarTexto.value)" #buscarTexto />
        <button (click)="buscarContendiente(buscarTexto.value)" class="btn btn-outline-success" type="submit">
          Buscar
        </button>
      </form> -->
      <!-- 
      <form class="d-flex">
        <input class="form-control me-2" type="search" placeholder="Search" aria-label="Search">
        <button class="btn btn-outline-success" type="submit">Search</button>
      </form> -->
    </div>
  </div>
</nav>


<div class="container-fluid movil-ocultar ">
  <div class="row">
    <div class="col-12 text-start">
      <small >
        <i class="fa fa-calendar"></i>
        <span id="current_date">{{ today }}</span>
        {{ leyendaSuperior }}
      </small>
    </div>
    <!-- <div class="col-4 text-end">

     

    </div> -->
  </div>
</div>